<template functional>
    <section class="card-section" :class="data.staticClass">
        <slot></slot>
    </section>
</template>

<script>
    export default {
        name: 'CardSection'
    }
</script>

<style scoped lang="scss">
    .card-section {
        padding: .75rem 1.25rem;

        &:not(:last-child) {
            border-bottom: 1px solid hsla(0, 0%, 0%, 0.12);
        }
    }
</style>
